module.exports = __webpack_public_path__ + "img/hp-knife-black-pearl.45cf47ab.png";